<template>
  <validation-observer ref="observer" v-slot="{ passes }">
    <div class="modal-card" style="width: auto">
      <header class="modal-card-head">
        <p class="modal-card-title">
          {{ titulo }}
        </p>
      </header>
      <div class="modal-card-body">
        <section>
          <validation-provider v-slot="{ errors, valid }" rules="required">
            <b-field
              label="Código"
              :type="{ 'is-danger': errors[0], 'is-success': valid }"
              :message="errors"
            >
              <b-input
                v-model="model.id"
                type="text"
                :disabled="modificacion"
              />
            </b-field>
          </validation-provider>
          <validation-provider v-slot="{ errors, valid }" rules="required">
            <b-field
              label="Nombre Sucursal"
              :type="{ 'is-danger': errors[0], 'is-success': valid }"
              :message="errors"
            >
              <b-input v-model="model.nombre" type="text" />
            </b-field>
          </validation-provider>
        </section>
      </div>
      <footer class="modal-card-foot">
        <div class="buttons">
          <b-button type="is-info" @click="passes(submit)">
            <span>Guardar</span>
          </b-button>
          <button class="button" @click="cerrarForm">
            <span>Salir</span>
          </button>
        </div>
      </footer>
    </div>
  </validation-observer>
</template>

<script>
import { ValidationObserver, ValidationProvider, extend } from 'vee-validate'
import { required } from 'vee-validate/dist/rules'

import { sucursalService } from '@/services'

extend('required', {
  ...required,
  message: 'Este campo es requerido'
})

export default {
  name: 'SucursalForm',
  components: {
    ValidationObserver,
    ValidationProvider
  },
  props: {
    titulo: {
      type: String,
      default: 'Agregar Registro'
    },
    modificacion: {
      type: Boolean,
      default: false
    },
    objeto: {
      type: Object,
      required: false,
      default: () => ({
        id: null,
        nombre: null
      })
    }
  },
  data: () => ({
    model: {
      id: null,
      nombre: null
    },
    cargando: false
  }),
  mounted() {
    this.modelo = Object.assign(this.model, this.objeto)
  },
  methods: {
    submit() {
      const self = this
      Promise.all([
        this.modificacion
          ? sucursalService.updateSucursal(self.objeto.id, self.model)
          : sucursalService.addSucursal(self.model)
      ])
        .then((rs) => {
          self.notificarAccionCompletada(
            `Se ${
              this.modificacion ? 'modificó' : 'agregó'
            } sucursal correctamente`
          )
          self.$emit('close', true)
        })
        .catch((error) => self.procesarError(error))
    },
    cerrarForm() {
      this.$emit('close', false)
    },
    resetForm() {
      this.id = ''
      this.nombre = ''
      requestAnimationFrame(() => {
        this.$refs.observer.reset()
      })
    }
  }
}
</script>
